import React from 'react';
import ReactDOM from 'react-dom/client';
/**CSS PATHS >>>>>*/
import 'rsuite/dist/rsuite.min.css'
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/plugins/select2/css/select2.min.css";
import "./assets/plugins/multipleselect/multiple-select.css";
import "./assets/plugins/summernote/summernote-bs4.css";
import "./assets/plugins/fileuploads/css/fileupload.css";
import "./assets/plugins/fancyuploder/fancy_fileupload.css";
import 'semantic-ui-css/semantic.min.css';
/**CSS PATHS <<<<<*/


/**JS PATHS >>>>>*/
import "bootstrap/dist/js/bootstrap.bundle.js";
import "jquery-ui/dist/jquery-ui.js"; //can be harmful
import "jquery-ui/ui/widgets/datepicker.js";
import "./assets/admin/bootstrap-daterangepicker/daterangepicker.js"
/**JS PATHS <<<<<*/

import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './store/store';
import { RouterProvider } from "react-router-dom";
import router from './App';

import loaderForPOS from './assets/company/img/loader-for-pos.gif';


// rsuite's overlays (the tooltips on the ERP error dots, pickers, tag inputs)
// observe elements through @juggle/resize-observer, whose spec-mandated
// "loop completed with undelivered notifications" notice is not a thrown error
// at all: the ponyfill builds an ErrorEvent and dispatches it on window itself
// (see its algorithms/deliverResizeLoopError.js). The dev server's overlay
// listens for window error events, so that benign notice paints a full-screen
// "Uncaught runtime errors" over the page while the tooltip works fine.
//
// Dropping it at the dispatch call is the one place that is order-independent —
// a listener of ours could still run after the overlay's. Only this exact
// synthetic notice is swallowed; every other error event passes through.
const nativeDispatchEvent = window.dispatchEvent.bind(window);
window.dispatchEvent = (event) => {
  const isResizeLoopNotice = event?.type === 'error'
    && typeof event.message === 'string'
    && event.message.startsWith('ResizeObserver loop');
  if (isResizeLoopNotice) {
    return true;
  }
  return nativeDispatchEvent(event);
};


// Scrolling the mouse wheel over a focused number input silently changes its
// value, so drop focus instead. Applies to every number field in the app.
document.addEventListener('wheel', () => {
  const activeElement = document.activeElement;
  if (activeElement && activeElement.type === 'number') {
    activeElement.blur();
  }
});


// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>
// );

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
      <Provider store={store}>
      {/* Old Global-Loader of website */}
      {/* <div className='global-loader' id='global_loader' style={{display:'flex'}}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div> */}

      {/* New Global-Loader of website */}
      <div className='global-loader' id='global_loader' style={{display:'flex'}}>
        <img src={loaderForPOS} alt="Loading..." />
      </div>
      <RouterProvider router={router} />
      </Provider>
  // </React.StrictMode>
);

reportWebVitals();
